import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: 'app-skeleton-document',
    templateUrl: './skeleton-document.component.html',
    styleUrls: ['./skeleton-document.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkeletonDocumentComponent {

}